// Iteration 1.14 — arena render path. The pre-1.14 canvas renderer lives
// here verbatim; canvas.js is now a mode router.
//
// Scanner-centric 2D renderer. Draws self at canvas center using the shown
// rotation, and every other ship at its world-space position relative to self.
// Scanner window is 16384 × 16384 world units (scaled to fit the viewport).

export const ScannerSize = 16384

const SPRITE_ROCKET_FLAG = 1 << 6

const COLORS = ['#88f', '#f77', '#7f7', '#fd7', '#f7f', '#7ff', '#fff', '#bbb']

export function renderArena(opts) {
  const { canvas, self, ships, projectiles } = opts
  const ctx = canvas.getContext('2d')
  const w = canvas.width
  const h = canvas.height
  const short = Math.min(w, h)
  const worldToScreen = short / ScannerSize

  ctx.fillStyle = '#000'
  ctx.fillRect(0, 0, w, h)

  if (!self) return

  ctx.save()
  ctx.translate(w / 2, h / 2)

  for (const s of ships.values()) {
    const dx = s.worldX - self.worldX
    const dy = s.worldY - self.worldY
    const sx = dx * worldToScreen
    const sy = -dy * worldToScreen
    drawShip(ctx, sx, sy, s.rotation, s.sprite)
  }
  drawShip(ctx, 0, 0, self.shownRotation, self.sprite)

  if (projectiles) {
    ctx.fillStyle = '#ffe'
    for (const p of projectiles.values()) {
      const dx = p.worldX - self.worldX
      const dy = p.worldY - self.worldY
      const sx = dx * worldToScreen
      const sy = -dy * worldToScreen
      ctx.beginPath()
      ctx.arc(sx, sy, 2, 0, Math.PI * 2)
      ctx.fill()
    }
  }

  ctx.restore()
}

function drawShip(ctx, sx, sy, rot, sprite) {
  ctx.save()
  ctx.translate(sx, sy)
  ctx.rotate(-rot)

  const color = COLORS[(sprite >>> 3) & 0x07]
  ctx.strokeStyle = color
  ctx.lineWidth = 1.5
  ctx.beginPath()
  ctx.moveTo(10, 0)
  ctx.lineTo(-6, 6)
  ctx.lineTo(-3, 0)
  ctx.lineTo(-6, -6)
  ctx.closePath()
  ctx.stroke()

  if ((sprite & SPRITE_ROCKET_FLAG) !== 0) {
    ctx.strokeStyle = '#f80'
    ctx.beginPath()
    ctx.moveTo(-3, 0)
    ctx.lineTo(-10 - Math.random() * 4, 0)
    ctx.stroke()
  }
  ctx.restore()
}
